import React, { useContext } from 'react';

import { Box, Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';

import { DeviceContext } from '@vyce/core/src/contexts';

import { useStyles } from './styles';
import { pdfType } from './config';
import { PDFPreview } from './components';
import { MAIN_CONTAINER_ID } from '../../constants';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

interface Props {
  url: string;
  type: 'img' | 'pdf';
  isOpen: boolean;
  bigPreview?: boolean;
  onClose: () => void;
  onPrev?: () => void;
  onNext?: () => void;
  hasPrev?: boolean;
  hasNext?: boolean;
}

export const PreviewDocumentDialog = ({
  url,
  type,
  isOpen,
  bigPreview,
  onClose,
  onPrev,
  onNext,
  hasPrev,
  hasNext,
}: Props) => {
  const classes = useStyles();
  const { isMobile } = useContext(DeviceContext);

  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      fullScreen={isMobile}
      maxWidth="xl"
      open={isOpen}
      onClose={onClose}>
      <DialogContent>
        <Box position="relative">
          {type === pdfType ? (
            <PDFPreview url={url} bigPreview />
          ) : (
            <>
              {onPrev && hasPrev && (
                <Button
                  onClick={onPrev}
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    minWidth: 0,
                    zIndex: 2,
                    background: 'rgba(255,255,255,0.7)',
                    borderRadius: '50%',
                    padding: 8,
                  }}
                  disabled={!hasPrev}>
                  <FiChevronLeft size={32} />
                </Button>
              )}
              <img alt="selectedImage" src={url} className={classes.selectedImage} />
              {onNext && hasNext && (
                <Button
                  onClick={onNext}
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    minWidth: 0,
                    zIndex: 2,
                    background: 'rgba(255,255,255,0.7)',
                    borderRadius: '50%',
                    padding: 8,
                  }}
                  disabled={!hasNext}>
                  <FiChevronRight size={32} />
                </Button>
              )}
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button size="large" variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PreviewDocumentDialog.PDFPreview = PDFPreview;
